import StaffPerformanceHTMLPreviewBaseColumnsStrategy from './StaffPerformanceHTMLPreviewBaseColumnsStrategy'

export default function StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype = new StaffPerformanceHTMLPreviewBaseColumnsStrategy()

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype.init = function(timeFormat, includeOtherUsersColumn, needSwitchToMe) {
    StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.init.call(this, timeFormat)
    this.needSwitchToMe = needSwitchToMe
    this.includeOtherUsersColumn = includeOtherUsersColumn
    return this
}

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype.addFirstHeaderRowCells = function(firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createSpentHeaderCell())
    this.addCreatedCell(firstHeaderRow, this.needSwitchToMe ? this.createMeHeaderCell(2) : this.createUserHeaderCell(2))
    if (!this.needSwitchToMe) this.addCreatedCell(firstHeaderRow, this.createUserHeaderCell(2))
    if (this.includeOtherUsersColumn) this.addCreatedCell(firstHeaderRow, this.createOthersHeaderCell(2))
}

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype.addSecondHeaderRowCells = function(secondHeaderRow) {
    // do nothing
}

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.createMeHeaderCell = function(rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.common.me"), "user", 1, rowSpan)
}

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.addDataCells = function(row) {
    this.addTimeValueCell(row, "spent")
    this.addTimeValueCell(row)
    if (!this.needSwitchToMe) this.addTimeValueCell(row)
    if (this.includeOtherUsersColumn) this.addTimeValueCell(row)
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.js